<template>
    <section class="container " style="margin-top: 0px !important">
        <div style="border: 1px solid #F2F2F2">
            <div style="text-align: center; background: #F9F8F6;border-bottom: 1px solid #F2F2F2;padding-bottom: 20px">
                <br />
                <span class="heading-title1">{{ $t('ACCOUNT_INFO_TITLE') }}</span>
                <br />{{ $t('ACCOUNT_INFO_PART_1') }}<br />{{ $t('ACCOUNT_INFO_PART_2') }}<br />
            </div>
            <div style="text-align: center;">
                <br />
                <span class="heading-title1">{{ $t('ACCOUNT_INFO_PART_5') }}</span>
            </div>
            <div style="margin-top: 20px">
                <div style="margin: auto;text-align: left;" class="w50">
                    <span class="stepOver"><span class="step">1</span></span>
                    {{ $t('ACCOUNT_INFO_PART_3') }} <br />{{ $t('ACCOUNT_INFO_PART_4') }}
                </div>
            </div>
            <div style="margin-top: 20px">
                <div class="w50" style="margin: auto;text-align: left;">
                    <span class="stepOver"><span class="step">2</span></span>
                    {{ $t('ACCOUNT_INFO_PART_6') }}
                    <ul class="ullist" style="margin-left: 20px">
                        <li>{{ $t('ACCOUNT_INFO_PART_7') }}</li>
                        <li>{{ $t('ACCOUNT_INFO_PART_8') }} <br />{{ $t('ACCOUNT_INFO_PART_9') }}</li>
                    </ul>
                </div>
            </div>
            <div style="margin-top: 20px">
                <div class="w50" style="margin: auto;text-align: left;">
                    <span class="stepOver"><span class="step">3</span></span
                    >{{ $t('ACCOUNT_INFO_PART_10') }}<br />
                    {{ $t('ACCOUNT_INFO_PART_11') }}
                </div>
            </div>
            <br />
            <div style="text-align: center; background: #F9F8F6;border-bottom: 1px solid #F2F2F2;padding-bottom: 20px">
                <br />
                <span class="heading-title"> {{ $t('ACCOUNT_INFO_PART_12') }}</span>
                <div style="width: 40%;margin: auto;text-align: left;margin-top: 20px">
                    <ul class="ullist">
                        <li>
                            {{ $t('ACCOUNT_INFO_PART_13') }}
                        </li>
                        <li>
                            {{ $t('ACCOUNT_INFO_PART_14') }}
                        </li>
                        <li>
                            {{ $t('ACCOUNT_INFO_PART_15') }}
                        </li>
                    </ul>
                </div>
            </div>
            <br />
            <div style="text-align: center;">
                <span class="heading-title1"> {{ $t('ACCOUNT_INFO_PART_16') }}</span>
                <br />
                <br />
                <button class="app-btn app-btn--big app-btn-primary" @click.prevent="gotoAccount">
                    {{ $t('ACCOUNT_INFO_PART_17') }}
                </button>
                <br />
                <br />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    methods: {
        gotoAccount() {
            this.$http.patch('/user/api/profile/showInfoSetToFalse/').then(() => this.$router.push('/'));
        },
    },
};
</script>

<style lang="scss">
.heading-title1 {
    font-family: 'Ek Mukta', sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 22px;
    color: #000000;
    text-align: center;
}

.stepOver {
    position: absolute;
    border: 1px solid #cf004a;
    padding: 5px;
    -moz-border-radius: 1.5em;
    -webkit-border-radius: 1.5em;
    border-radius: 1.5em;
    margin-left: -50px;
    margin-top: 5px;
}

span.step {
    background: #cf004a;
    border-radius: 0.8em;
    -moz-border-radius: 0.8em;
    -webkit-border-radius: 0.8em;
    color: #ffffff;
    display: inline-block;
    font-weight: bold;
    line-height: 1.6em;

    text-align: center;
    width: 1.6em;
}

.ullist {
    list-style: none;
}

.ullist li:before {
    position: absolute;
    content: '✓';
    margin-left: -20px;
    color: green;
}

.w50 {
    width: 50%;
}

@media only screen and (max-width: 768px) {
    .w50 {
        width: 62%;
    }
}

@media only screen and (min-width: 768px) {
    .container {
        width: 90%;
    }
}
</style>



// WEBPACK FOOTER //
// account-info.vue?0c51f990